const APP_SCHEME = 'bieases://';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.suchusa.bieaseseu';
const APP_STORE_URL = 'https://apps.apple.com/us/app/bieases/id6503137093';

export const checkAppInstalled = async () => {
    return new Promise((resolve) => {
        const timeout = setTimeout(() => {
            resolve(false);
        }, 2000);

        window.location.href = APP_SCHEME;

        window.onblur = () => {
            clearTimeout(timeout);
            resolve(true);
        };
    });
};

export const openApp = async (storeType) => {
    const isInstalled = false;  // await checkAppInstalled();

    if (isInstalled) {
        window.location.href = APP_SCHEME;
    } else {
        const storeUrl = storeType === 'google' ? PLAY_STORE_URL : APP_STORE_URL;
        window.location.href = storeUrl;
    }
};